import { createMultiStyleConfigHelpers, } from "@chakra-ui/styled-system";
import { Sizes } from "../ErrorPage.types";
import { textStyles } from "../../../../theme/foundations/generated";
import { BackgroundVariant as BgVariant } from "../../../atoms";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers([
    "mainContainer",
    "errorTitle",
    "errorTitleText",
    "errorLogo",
    "errorFooter",
]);
const baseStyle = definePartsStyle(({ errorCode, size }) => ({
    mainContainer: Object.assign({ display: "flex", width: "100%", height: "100%", alignItems: "center", justifyContent: "center", position: "relative", flexDirection: "column" }, (errorCode
        ? {
            _before: {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
                content: `'${errorCode}'`,
                fontSize: ["130px", "130px", "294px", "460px"],
                fontStyle: "normal",
                fontWeight: 900,
                lineHeight: "110%" /* 506px */,
                letterSpacing: ["-8.1px", "-8.1px", "-14.7px", "-23px"],
                color: "semantic.surface.skeleton",
            },
        }
        : {})),
    errorTitle: {
        paddingBottom: ["2", "2", "2"],
        alignItems: "center",
    },
    errorTitleText: Object.assign(Object.assign({ paddingLeft: "3" }, (size === Sizes.LG || size === Sizes.MD
        ? textStyles.heroTitle.desktopMediumBlack
        : textStyles.title.mobilePage)), { color: "semantic.text.primary" }),
    errorLogo: {
        zIndex: 1,
        paddingBottom: ["2", "2", "2", errorCode ? "10" : "2"],
    },
    errorFooter: {
        paddingBottom: ["14", "14", "10", "10"],
        color: "semantic.text.primary",
        span: Object.assign({}, (size === Sizes.LG || size === Sizes.MD
            ? textStyles.title.desktopSection
            : textStyles.title.mobileSection)),
    },
}));
const variants = {
    xmarkVariant: definePartsStyle(({ size, titleLabel }) => ({
        mainContainer: Object.assign({ display: "flex", width: "100%", height: "100%", alignItems: "center", justifyContent: "center", position: "relative", flexDirection: "column" }, (titleLabel
            ? {
                _before: Object.assign(Object.assign({ position: "absolute", top: "45%", left: "50%", transform: "translate(-50%, -50%)", textAlign: "center", content: `'${titleLabel}'` }, (size === Sizes.LG || size === Sizes.MD
                    ? textStyles.heroTitle.desktopMediumBlack
                    : textStyles.title.mobilePage)), { color: "semantic.text.primary" }),
            }
            : {})),
        errorTitle: {
            ".downtime-icon": {
                paddingBottom: ["4", "4", "4"],
            },
            alignItems: "center",
        },
        errorFooter: {
            paddingBottom: ["14", "14", "10", "10"],
            color: "semantic.text.primary",
            whiteSpace: "pre",
            span: Object.assign({}, (size === Sizes.LG || size === Sizes.MD
                ? textStyles.title.desktopSection
                : textStyles.title.mobileSection)),
        },
    })),
    backgroundVariant: definePartsStyle(({ size }) => ({
        mainContainer: {
            display: "flex",
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            flexDirection: "column",
        },
        errorTitle: {
            paddingTop: ["144px", "112px", "180px"],
            px: ["48px", "48px", "124px"],
            paddingBottom: ["24px", "24px", "56px"],
            span: Object.assign({ p: 0 }, (size === BgVariant.CHEVRON || size === BgVariant.SLOPEMD
                ? textStyles.heroTitle.desktopMediumBlack
                : textStyles.title.mobilePage)),
        },
        errorFooter: {
            px: ["48px", "48px", "124px"],
            color: "semantic.text.primary",
            whiteSpace: "pre",
            span: Object.assign({}, (size === BgVariant.CHEVRON || size === BgVariant.SLOPEMD
                ? textStyles.title.desktopSection
                : textStyles.title.mobileSection)),
        },
    })),
};
const ErrorPageTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
});
export default ErrorPageTheme;
//# sourceMappingURL=ErrorPage.default.js.map